import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ReceptionCompaniesBrowse from '../panels/ReceptionCompaniesBrowse';
import { ReceptionPageHeader } from '../ui';

export default function ReceptionCompaniesPage() {
  const { toast } = useOutletContext();
  return (
    <div className="recv-dash-pro recv-dash-pro--main">
      <ReceptionPageHeader
        badge="Partenaires"
        title="Sociétés"
        description="Annuaire des sociétés partenaires actives — consultation en lecture seule."
      />
      <ReceptionCompaniesBrowse toast={toast} />
    </div>
  );
}
